import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { ApiService } from '../../services/api/api.service';
import { Data } from '../../models/data';
import { NavController } from '@ionic/angular';
import { Router, NavigationEnd } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Nav } from '../../models/nav';
import { NavService } from '../../services/nav/nav.service';
import * as moment from 'moment';


export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage implements OnInit, OnDestroy {

  //idleState = "Not started.";

  open(menu)
  {
    menu.openMenu();
  }
  
  data = new Data();

  user: any;
  wallet: any;
  image: any;
  categories = [];
  navigationSubscription;
  cantopup: any;

  current_year: number = new Date().getFullYear();
  currentTime: string = moment().format('M/D/YYYY hh:mm:ss a');



  constructor(private authService: AuthService,
              private apiService: ApiService,
              private navCtrl: NavController,
              private spinner: NgxSpinnerService,
              public dialog: MatDialog,
              private navService: NavService,
              private router: Router) {
    this.image = 'assets/img/user/nophoto.png';

    this.data =  {
      id: 2,
      name: 'getParamDashboard',
      content: localStorage.getItem('user')
    };

    /*this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.initialiseInvites();
      }
    });*/

  }

  ngOnInit() {
    this.refresh();

    /*console.log((Math.round(2.29*20)/20).toFixed(2));
    console.log((Math.round(2.30*20)/20).toFixed(2));
    console.log((Math.round(2.31*20)/20).toFixed(2));
    console.log((Math.round(2.32*20)/20).toFixed(2));
    console.log((Math.round(2.33*20)/20).toFixed(2));
    console.log((Math.round(2.34*20)/20).toFixed(2));
    console.log((Math.round(2.35*20)/20).toFixed(2));
    console.log((Math.round(2.36*20)/20).toFixed(2));
    console.log((Math.round(2.37*20)/20).toFixed(2));
    console.log((Math.round(2.38*20)/20).toFixed(2));
    console.log((Math.round(2.39*20)/20).toFixed(2));
    console.log((Math.round(2.40*20)/20).toFixed(2));
    console.log((Math.round(2.41*20)/20).toFixed(2));*/
          


  }

  refresh() {

    this.spinner.show();
    this.apiService.postData(this.data).subscribe((response) => {
      this.wallet = response.data.wallet;
      this.user = response.data.user;
      this.categories = response.data.category;
      console.log(response);
      localStorage.setItem('firstname', this.user.firstname);
      localStorage.setItem('lastname', this.user.lastname);
      localStorage.setItem('companyg', this.user.companyg);
      localStorage.setItem('address', this.user.addr);
      localStorage.setItem('phone', this.user.telephone);
      localStorage.setItem('email', this.user.email);
      localStorage.setItem('wallet', this.wallet);

      this.spinner.hide();

      if( response.data.user.acc_type == 1 && response.data.user.level_class_id==3) this.cantopup = 1;
      else this.cantopup = 0;
      localStorage.setItem('cantopup', this.cantopup);
      localStorage.setItem('tml', response.data.user.acc_type);
      localStorage.setItem('level', response.data.user.level_class_id);
      /*if ( this.wallet <= 500 ) {
        this.openDialog();
      }*/
      console.log(response.data.user.acc_type);
      console.log(response.data.user.level_class_id);
      console.log('cantopup' + this.cantopup);
    });

  }

  getCatId(int) {
    if (this.categories.length > 0 ) {
      return this.categories[int].category_id;
    } else {
      return null;
    }
  }

  getLabel(int) {
    if (this.categories.length > 0 ) {
      return this.categories[int].dexpay_label;
    } else {
      return null;
    }
  }

  getImage(int) {
     //console.log(this.categories);
     if (this.categories.length > 0 ) {
      //console.log('/assets/img/' + this.categories[int].image);
      return '/assets/img/' + this.categories[int].image;
    } else {
      return null;
    }
  }

  getFirstName() {
    //console.log(this.user);
    if (this.user) {
      return this.user.firstname;
    } else {
      return null;
    }
  }

  getLastName() {
    //console.log(this.user);
    if (this.user) {
      return this.user.lastname;
    } else {
      return null;
    }
  }

  getCompany() {
    //console.log(this.user);
    if (this.user) {
      return this.user.companyg;
    } else {
      return null;
    }
  }

  setLogout() {
    this.authService.logout();
  }

  topup() {
    this.navCtrl.navigateForward('/members/wallet');
  }

  initialiseInvites() {
    this.wallet = localStorage.getItem('wallet');
    this.apiService.postData(this.data).subscribe((response) => {
    console.log(response);
    this.wallet = response.data.wallet;
    this.user = response.data.user;
    this.categories = response.data.category;
    localStorage.setItem('wallet', response.data.wallet);
    });
  }
  ngOnDestroy() {

     if (this.navigationSubscription) {
        this.navigationSubscription.unsubscribe();
     }
   }

   getWallet() {
     return this.wallet;
   }

   openDialog(): void {
    const dialogRef = this.dialog.open(DialogPage, {
      width: '280px',
      data: {name: 'name', animal: 'hello'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  logout() {
    this.authService.logout();
  }





}

@Component({
  selector: 'mydialog',
  templateUrl: 'dialog.html',
})
export class DialogPage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

}
